import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStackedBarChartAxis2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"stacked-bar-chart-axis-2"} maskId="square-filled-radius-0-stroke-1-IconStackedBarChartAxis2"><path d="M4 20H21V21H3V3H4V20Z" fill="currentColor"/><path d="M12 19H7V9H12V19Z" fill="currentColor"/><path d="M18 19H13V6H18V19Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconStackedBarChartAxis2;
